import { v4 as uuidv4 } from 'uuid';

export const BooleanJsonSchemaWidget = ({
  value,
  onChange,
}: {
  value: boolean;
  onChange: (newValue: boolean | undefined) => void;
}): JSX.Element => {
  const id = uuidv4();
  return (
    <div className={'form-check form-switch switch-colored'}>
      <input
        id={id}
        type={'checkbox'}
        className={'form-check-input'}
        checked={value}
        onChange={() => onChange(!value)}
      />
      <label className="form-check-label" htmlFor={id} />
    </div>
  );
};
